import { useMutation, useQueryClient } from '@tanstack/react-query';

import { captureException } from '#lib/sentry';

import { abortGoogleMapsScrapingJob } from '../../api/googleMapsScraperApi';
import { abortContactEnrichmentJob } from '../../api/leadApi';
import { prospectQueryKeys } from '../prospectQueries/keys';

/**
 * Mutation hook to abort a running search job (GoogleMaps or ContactEnrichment)
 * @returns {UseMutationResult} React Query mutation result
 */
export const useAbortSearchJob = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ jobId, jobType }) => {
			if (jobType === 'contactEnrichment') {
				return abortContactEnrichmentJob(jobId);
			}
			if (jobType === 'googleMapsScraper') {
				return abortGoogleMapsScrapingJob(jobId);
			}
			throw new Error(`Unknown job type: ${jobType}`);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: prospectQueryKeys.all });
		},
		onError: (error, { jobId, jobType }) => {
			captureException(error, {
				tags: {
					section: 'lead-overview',
					operation: 'abort-search-job',
				},
				extra: {
					jobId,
					jobType,
				},
				level: 'error',
			});
		},
	});
};
